import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { FiPhone } from 'react-icons/fi';
import { CONTATO_ENCERRAMENTO } from '~/config/encerramentoSistema';
import { BotaoWhatsapp, ContainerContato } from './styles';

const CartaoContato: React.FC = () => {
  const { nome, empresa, telefone, linkWhatsapp } = CONTATO_ENCERRAMENTO;

  return (
    <ContainerContato>
      <span className="rotulo">Em caso de dúvidas, fale com:</span>
      <div className="dados">
        <div className="pessoa">
          <strong>{nome}</strong>
          <span>{empresa}</span>
          <span className="telefone">
            <FiPhone size={14} aria-hidden />
            {telefone}
          </span>
        </div>
        <BotaoWhatsapp
          href={linkWhatsapp}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp size={18} aria-hidden />
          Falar no WhatsApp
        </BotaoWhatsapp>
      </div>
    </ContainerContato>
  );
};

export default CartaoContato;
